import { t } from '../../../locales';
import CreateReturnButton from './pages/orders-returns-list/components/create-return-btn.vue';
import RefundOrderButton from './pages/order-returns-details/components/refund-order-btn.vue';
import OrderDetailsHeaderTitle from './pages/order-details/components/header-title.vue';
import OrderDetailsHeaderExtra from './pages/order-details/components/header-extra.vue';
import OrdersListHeaderActions from './pages/orders-list/components/header-actions.vue';
import { featureFlag } from '../../entities/feature-flag';

const ordersModuleRoutes = {
	path: 'orders',
	component: () => import('./module-layout.vue'),
    meta: {
        featureFlag: featureFlag.E_COMMERCE,
    },
	children: [
		{
			path: 'returns',
			component: () => import(/* webpackChunkName: "order-return-module" */ './pages/orders-returns-list/index.vue'),
			meta: {
				title: t('orders.orders-returns'),
				headerExtraComponent: CreateReturnButton,
			},
		},
		{
			path: 'returns/:id',
			props: true,
			component: () => import(/* webpackChunkName: "order-return-module" */ './pages/order-returns-details/index.vue'),
			meta: {
				title: t('orders.order-return-details'),
				headerExtraComponent: RefundOrderButton,
			},
		},
        {
			path: 'details/:id',
			props: true,
			component: () => import('./pages/order-details/index.vue'),
			meta: {
				title: t('orders.order-details'),
				headerTitleComponent: OrderDetailsHeaderTitle,
				headerExtraComponent: OrderDetailsHeaderExtra,
			},
		},
        {
			path: 'list',
			component: () => import('./pages/orders-list/index.vue'),
			meta: {
				title: t('orders.orders'),
				headerExtraComponent: OrdersListHeaderActions,
            }
        },
        {
			path: 'print/:id',
            props: true,
            name: 'order-print',
			component: () => import('./components/order-view/index.vue'),
			meta: {
				title: t('orders.orders')
            }
        },
	],
};

export { ordersModuleRoutes };
